const size = {
  mobile: "425px",
  tablet: "790px",
  desktop: "1200px",
};

export const device = {
  mobile: `(min-width: ${size.mobile})`,
  tablet: `(min-width: ${size.tablet})`,
  desktop: `(min-width: ${size.desktop})`,
};
